import { Text, Square } from '@chakra-ui/react';

type EmptySectionProps = {
  content: string;
};

export default function EmptySection({ content }: EmptySectionProps) {
  return (
    <Square bgColor="gray.100" py={10} borderRadius="5px">
      <Text color="gray.500">{content}</Text>
    </Square>
  );
}
